export { registerLibrary, registerDirectoryLibrary, registerLocalIcon } from './icon/library.js';

import { UwcFileupload }   from './fileupload/index.js';
import { UwcForm }         from './form/index.js';
import { UwcFormField }    from './formfield/index.js';
import { UwcBreadcrumb }   from './breadcrumb/index.js';
import { UwcTree }          from './tree/index.js';
import { UwcToolbar }      from './toolbar/index.js';
import { UwcAutocomplete }    from './autocomplete/index.js';
import { UwcEditor }          from './editor/index.js';
import { UwcSelectButton }    from './selectbutton/index.js';
import { UwcSlider }          from './slider/index.js';
import { UwcRating }          from './rating/index.js';
import { UwcTextarea }        from './textarea/index.js';
import { UwcVirtualScroller } from './virtualscroller/index.js';
import { UwcStepper, UwcStepperPanel } from './stepper/index.js';
import { UwcPanel }        from './panel/index.js';
import { UwcMessage }      from './message/index.js';
import { UwcToast }        from './toast/index.js';
import { UwcButton }       from './button/index.js';
import { UwcSplitButton }  from './splitbutton/index.js';
import { UwcCard }         from './card/index.js';
import { UwcCarousel }     from './carousel/index.js';
import { UwcGalleria }    from './galleria/index.js';
import { UwcAccordion, UwcAccordionPanel } from './accordion/index.js';
import { UwcTabs, UwcTabPanel }           from './tabs/index.js';
import { UwcSplitter, UwcSplitterPanel } from './splitter/index.js';
import { UwcCheckbox }     from './checkbox/index.js';
import { UwcDialog }       from './dialog/index.js';
import { UwcDrawer }       from './drawer/index.js';
import { UwcColorPicker }  from './colorpicker/index.js';
import { UwcDatatable, UwcColumn } from './datatable/index.js';
import { UwcDatepicker }   from './datepicker/index.js';
import { UwcDropdown }     from './dropdown/index.js';
import { UwcIcon }         from './icon/index.js';
import { UwcInputNumber }  from './inputnumber/index.js';
import { UwcInputText }    from './inputtext/index.js';
import { UwcListbox }      from './listbox/index.js';
import { UwcMenu }         from './menu/index.js';
import { UwcMenubar }      from './menubar/index.js';
import { UwcMegaMenu }     from './megamenu/index.js';
import { UwcPanelMenu }    from './panelmenu/index.js';
import { UwcSidebar }      from './sidebar/index.js';
import { UwcOverlay }      from './overlay/index.js';
import { UwcPaginator }    from './paginator/index.js';
import { UwcPopover }      from './popover/index.js';
import { UwcRadioButton }  from './radiobutton/index.js';
import { UwcToggleButton } from './togglebutton/index.js';
import { UwcToggleSwitch } from './toggleswitch/index.js';
import { UwcBadge }        from './badge/index.js';
import { UwcChip }         from './chip/index.js';
import { UwcLink }         from './link/index.js';
import { UwcTag }          from './tag/index.js';
import { UwcTooltip }      from './tooltip/index.js';

customElements.define('uwc-fileupload',    UwcFileupload);
customElements.define('uwc-form',          UwcForm);
customElements.define('uwc-form-field',    UwcFormField);
customElements.define('uwc-breadcrumb',    UwcBreadcrumb);
customElements.define('uwc-tree',          UwcTree);
customElements.define('uwc-toolbar',       UwcToolbar);
customElements.define('uwc-autocomplete',    UwcAutocomplete);
customElements.define('uwc-editor',          UwcEditor);
customElements.define('uwc-selectbutton',    UwcSelectButton);
customElements.define('uwc-slider',          UwcSlider);
customElements.define('uwc-rating',          UwcRating);
customElements.define('uwc-textarea',        UwcTextarea);
customElements.define('uwc-virtualscroller', UwcVirtualScroller);
customElements.define('uwc-stepper',       UwcStepper);
customElements.define('uwc-stepper-panel', UwcStepperPanel);
customElements.define('uwc-panel',        UwcPanel);
customElements.define('uwc-message',      UwcMessage);
customElements.define('uwc-toast',        UwcToast);
customElements.define('uwc-button',       UwcButton);
customElements.define('uwc-splitbutton',  UwcSplitButton);
customElements.define('uwc-card',         UwcCard);
customElements.define('uwc-carousel',  UwcCarousel);
customElements.define('uwc-galleria',  UwcGalleria);
customElements.define('uwc-checkbox',     UwcCheckbox);
customElements.define('uwc-dialog',       UwcDialog);
customElements.define('uwc-drawer',       UwcDrawer);
customElements.define('uwc-colorpicker',  UwcColorPicker);
customElements.define('uwc-datatable',    UwcDatatable);
customElements.define('uwc-column',       UwcColumn);
customElements.define('uwc-datepicker',   UwcDatepicker);
customElements.define('uwc-dropdown',     UwcDropdown);
customElements.define('uwc-icon',         UwcIcon);
customElements.define('uwc-inputnumber',  UwcInputNumber);
customElements.define('uwc-inputtext',    UwcInputText);
customElements.define('uwc-listbox',      UwcListbox);
customElements.define('uwc-menu',         UwcMenu);
customElements.define('uwc-menubar',      UwcMenubar);
customElements.define('uwc-megamenu',     UwcMegaMenu);
customElements.define('uwc-panelmenu',    UwcPanelMenu);
customElements.define('uwc-sidebar',      UwcSidebar);
customElements.define('uwc-overlay',      UwcOverlay);
customElements.define('uwc-paginator',    UwcPaginator);
customElements.define('uwc-popover',      UwcPopover);
customElements.define('uwc-radiobutton',  UwcRadioButton);
customElements.define('uwc-togglebutton', UwcToggleButton);
customElements.define('uwc-toggleswitch', UwcToggleSwitch);
customElements.define('uwc-badge',         UwcBadge);
customElements.define('uwc-chip',          UwcChip);
customElements.define('uwc-link',          UwcLink);
customElements.define('uwc-tag',           UwcTag);
customElements.define('uwc-tooltip',       UwcTooltip);
customElements.define('uwc-accordion',       UwcAccordion);
customElements.define('uwc-accordion-panel', UwcAccordionPanel);
customElements.define('uwc-tabs',            UwcTabs);
customElements.define('uwc-tab-panel',       UwcTabPanel);
customElements.define('uwc-splitter',        UwcSplitter);
customElements.define('uwc-splitter-panel',  UwcSplitterPanel);
